<template lang='pug'>
//- Side-Effect-Page
div(:class='$style[`cc-side-effect-user`]')
  div(v-if='!isConsultInnerRoom && rwdType === `desktop`' :class='$style[`cc-side-effect-user-topper`]')
    div(:class='$style[`cc-side-effect-user-board`]')
      div(:class='$style[`cc-side-effect-user-profile`]')
        div(:class='$style[`cc-side-effect-user-welcome`]')
          span.font-bold(v-if='$route.name === `effect-record` || $route.name === `effect-summary`') 我的紀錄
          span.font-bold(v-else-if='$route.name === `effect-post`') 建立新記錄
          span.font-bold(v-else-if='$route.name === `effect-consult`') 線上問醫生
          span.font-bold(v-else-if='$route.name === `effect-translator`') 報告翻譯
          span.font-bold(v-else-if='$route.name === `effect-profile`') 我的病歷資料
          span.font-bold(v-else-if='$route.name === `effect-diet`') 飲食管家

      div(:class='$style[`cc-side-effect-analysis`]')
        div(:class='$style[`cc-side-effect-analysis-block`]')
          header(:class='$style[`cc-side-effect-analysis-header`]' style='display: block')
            span.font-bold(:class='$style[`cc-side-effect-analysis-title`]') 建議每週至少完成 2 次記錄
            span.font-regular(:class='$style[`cc-side-effect-analysis-tip`]' style='padding: 3px 0 0') 提醒您，請定期更新病歷以提供精準內容

            //- span.font-bold(:class='$style[`cc-side-effect-analysis-title`]') 後續療程預測
            //- span.font-regular(:class='$style[`cc-side-effect-analysis-tip`]') 每4次紀錄自動執行 (還缺{{ 4 - loginProfile.analysis_count }}筆)
          //- div(:class='$style[`cc-side-effect-analysis-main`]')
          //-   ProgressBar(
          //-     :loadAnimate='false'
          //-     :label='loginProfile.analysis_count'
          //-     :maxLabel='4')
        //- div(v-else :class='$style[`cc-side-effect-analysis-block`]')
        //-   header(:class='$style[`cc-side-effect-analysis-header`]')
        //-     span.font-bold(:class='$style[`cc-side-effect-analysis-title`]') 建議每週至少做 2 次記錄
        //-     span.font-regular(:class='$style[`cc-side-effect-analysis-tip`]')
        //-       IconLocker(:size='16' :color='`#999`')
        //-       != '請先訂閱'
        //-   div(:class='$style[`cc-side-effect-analysis-main`]')
        //-     ProgressBar(
        //-       :loadAnimate='false'
        //-       :label='0'
        //-       :maxLabel='4')

      div(:class='$style[`cc-side-effect-user-post`]')
        router-link(
          role='button'
          tabindex='0'
          aria-label='建立新記錄'
          to='/sideeffect/post'
          :class='$style[`cc-side-effect-user-post-btn`]')
          span.font-medium + 建立新記錄

        //- button.font-medium(
        //-   tabindex='0' aria-label='抗癌金句'
        //-   :class='$style[`cc-side-effect-user-post-knowledge`]'
        //-   @click='handleClickToShowGoldKnowledge')
        //-   IconIdeas(:size='20')
        //-   span 抗癌金句

    //- 平板/手機
    //- div(v-else :class='$style[`cc-side-effect-user-board-mobile`]')
    //-   div(:class='$style[`cc-side-effect-user-profile`]')
    //-     div(:class='$style[`cc-side-effect-user-profile-thumb`]')
    //-       //- div(v-if='loginProfile.verified === `yes`' :class='[$style[`cc-side-effect-profile-verify`], $style[`cc-is-verify`]]')
    //-       //-   div(:class='$style[`cc-side-effect-profile-verify-icon`]')
    //-       //-     IconConfirm(:size='10' :color='`#fff`')

    //-       //- div(v-else :class='$style[`cc-side-effect-profile-verify`]')
    //-       //-   div(:class='$style[`cc-side-effect-profile-verify-icon`]')
    //-       //-     IconConfirm(:size='10' :color='`#fff`')

    //-       figure(v-if='loginProfile.thumbSrc === `` && !loginProfile.public' :class='$style[`cc-side-effect-profile-board-avatar`]')
    //-         img(
    //-           v-if='loginProfile.gender === `0`'
    //-           :src='`${STATIC_URL}images/common/user/normal_male.webp`'
    //-           width='100%'
    //-           height='100%')
    //-         img(
    //-           v-else
    //-           :src='`${STATIC_URL}images/common/user/normal_female.webp`'
    //-           width='100%'
    //-           height='100%')

    //-       figure(v-else-if='loginProfile.thumbSrc !== `` && !loginProfile.public' :class='$style[`cc-side-effect-profile-board-avatar`]')
    //-         img(
    //-           v-if='loginProfile.gender === `0`'
    //-           :src='`${STATIC_URL}images/common/user/normal_male.webp`'
    //-           width='100%'
    //-           height='100%')
    //-         img(
    //-           v-else
    //-           :src='`${STATIC_URL}images/common/user/normal_female.webp`'
    //-           width='100%'
    //-           height='100%')

    //-       figure(v-else-if='loginProfile.thumbSrc === `` && loginProfile.public' :class='$style[`cc-side-effect-profile-board-avatar`]')
    //-         img(
    //-           v-if='loginProfile.gender === `0`'
    //-           :src='`${STATIC_URL}images/common/user/normal_male.webp`'
    //-           width='100%'
    //-           height='100%')
    //-         img(
    //-           v-else
    //-           :src='`${STATIC_URL}images/common/user/normal_female.webp`'
    //-           width='100%'
    //-           height='100%')

    //-       figure(v-else-if='loginProfile.thumbSrc !== `` && loginProfile.public' :class='$style[`cc-side-effect-profile-board-avatar`]')
    //-         img(
    //-           :src='avatarSrcLink(loginProfile.thumbSrc)'
    //-           width='100%'
    //-           height='100%')

    //-     div(:class='$style[`cc-side-effect-user-dashboard`]')
    //-       div(:class='$style[`cc-side-effect-user-welcome`]')
    //-         span.font-bold(v-if='$route.name === `effect-record`') 副作用紀錄
    //-         span.font-bold(v-else-if='$route.name === `effect-post`') 建立新記錄
    //-         span.font-bold(v-else-if='$route.name === `effect-consult`') 線上諮詢室
    //-         //- span.font-bold(v-else-if='$route.name === `effect-aidoctor`') QA問答庫
    //-         span.font-bold(v-else-if='$route.name === `effect-translator`') 報告翻譯
    //-         span.font-bold(v-else-if='$route.name === `effect-profile`') 我的病歷資料

    //-       //- div(:class='$style[`cc-side-effect-user-status`]')
    //-       //-   div(:class='$style[`cc-side-effect-sidebar-score`]')
    //-       //-     nav(:class='$style[`cc-side-effect-sidebar-score-nav`]')
    //-       //-       span.border-gradient(v-if='subscribeVip === `yes`' :class='$style[`cc-side-effect-sidebar-score-nav-vip`]') VIP會員
    //-       //-       span(v-else :class='$style[`cc-side-effect-sidebar-score-nav-free`]') 基本會員
    //-       //-     nav(:class='$style[`cc-side-effect-sidebar-score-nav`]')
    //-       //-       IconCcoin(:size='24')
    //-       //-       span.font-medium(v-if='loginProfile.point' :class='$style[`cc-side-effect-sidebar-score-nav-coin`]') {{ loginProfile.point }}
    //-       //-         span.font-regular(:class='$style[`cc-detail-status-hp-tips`]') 幣
    //-       //-       span.font-medium(v-else :class='$style[`cc-side-effect-sidebar-score-nav-coin`]') 0
    //-       //-         span.font-regular(:class='$style[`cc-detail-status-hp-tips`]') 幣

    //-   div(:class='$style[`cc-side-effect-user-post`]')
    //-     router-link.font-medium.btn-normal-extra(
    //-       role='button'
    //-       tabindex='0'
    //-       aria-label='建立新記錄'
    //-       to='/sideeffect/post'
    //-       :class='$style[`cc-side-effect-user-post-btn`]') + 新記錄

    //-     //- router-link.font-medium(
    //-     //-   role='button'
    //-     //-   tabindex='0'
    //-     //-   aria-label='病歷資料'
    //-     //-   to='/ecard'
    //-     //-   :class='$style[`cc-side-effect-user-post-myprofile`]') 我的病歷

    //-     button.font-medium(
    //-       tabindex='0' aria-label='抗癌金句'
    //-       :class='$style[`cc-side-effect-user-post-knowledge`]'
    //-       @click='handleClickToShowGoldKnowledge')
    //-       IconIdeas(:size='20')
    //-       span 抗癌金句

  //- div(v-if='!isConsultInnerRoom' :class='$style[`cc-side-effect-analysis`]')
  //-   div(:class='$style[`cc-side-effect-analysis-block`]')
  //-     header(:class='$style[`cc-side-effect-analysis-header`]')
  //-       span.font-bold(:class='$style[`cc-side-effect-analysis-title`]') 後續療程預測
  //-       span.font-regular(:class='$style[`cc-side-effect-analysis-tip`]') 每4次紀錄自動執行

  //-     div(v-if='subscribeVip === `yes`' :class='$style[`cc-side-effect-analysis-main`]')
  //-       ProgressBar(
  //-         :loadAnimate='false'
  //-         :label='loginProfile.analysis_count'
  //-         :maxLabel='4')
  //-       div(:class='$style[`cc-side-effect-analysis-counter`]')
  //-         span 還缺{{ 4 - loginProfile.analysis_count }}筆
  //-     div(v-else :class='$style[`cc-side-effect-analysis-main`]')
  //-       ProgressBar(
  //-         :loadAnimate='false'
  //-         :label='0'
  //-         :maxLabel='4')
  //-       div(:class='$style[`cc-side-effect-analysis-counter`]')
  //-         IconLocker(:size='16' :color='`#999`')
  //-         span 請先訂閱

  div(:class='$style[`cc-side-effect-user-container`]')
    router-view

</template>

<script>
import { mapGetters } from 'vuex';
// import GlobalEmitter from 'tiny-emitter/instance';

// import { mixin as clickaway } from 'vue-clickaway';
import IconLocker from '../../icon/Locker';
import ProgressBar from '../common/ProgressBar';
// import { debounce } from 'debounce';

export default {
  components: {
    IconLocker,
    ProgressBar,
  },

  // mixins: [clickaway],

  // data() {
  //   return {
  //   };
  // },

  // methods: {
  // ...mapMutations({
  // changePopBoxStatus: 'global/POPBOX_STATUS',
  // changePopTranslatorStatus: 'global/POPTRANSLATOR_STATUS',
  // changePopShowTutorialStatus: 'global/POPSHOW_TUTORIAL_STATUS',
  // changePopProgressStatus: 'global/POPPROGRESS_STATUS',
  // }),

  // handleClickToShowGoldKnowledge() {
  //   this.changePopShowTutorialStatus({
  //     active: true,
  //     include: 'gold-knowledge',
  //   });
  // }
  // },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
      loginProfile: 'user/exportUserProfile',
      subscribeVip: 'user/exportUserSubscribeVip',
      // loginDjangoId: 'user/exportUserDjangoId',
      // loginStatus: 'user/exportLoginStatus',
      // loginHashCode: 'user/exportUserHashCode',
      // loginSubscribeValid: 'user/exportUserSubscribeValid',
    }),

    isConsultInnerRoom() {
      const router = this.$route;
      return router.name === 'effect-consult' && router.query.v ? true : false;
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effectBoard.scss';
</style>
